import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the FixedPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'fixed',
})
export class FixedPipe implements PipeTransform {

  transform(input) {
    {
      if(typeof input == "string")
        input = input.replace(/,/g, '');
      let dp = decimalPlaces(input);
      let inputWithOutDp = Math.floor(input);

      if (inputWithOutDp >= 100) {
        return inputWithOutDp;
      }
      if(dp == 0){
        return input;
      }
      if (dp < 2) {
        return Number(input).toFixed(dp);
      }
      else {
        return Number(input).toFixed(2);
      }
    }

    function decimalPlaces(number) {
      return ((Number(number)).toFixed(20)).replace(/^-?\d*\.?|0+$/g, '').length;
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/fixed/fixed.ts